module.exports = __webpack_public_path__ + "img/logoAPHP_CCelton.e0cdc42d.jpg";